import { em } from 'polished'
import styled, { css } from 'styled-components'

import { GOODS_TYPES } from 'constants/sales'
import { Text } from 'styles/components/typography'

const { wgs, dna } = GOODS_TYPES

export const Wrapper = styled.div`
  grid-area: ${({ type }) => type};

  ${({ type }) =>
    type === wgs &&
    css`
      ${ImageWrapper} {
        padding-left: ${em(6)};
        margin-right: ${em(28)};
      }
      margin-bottom: ${em(40)};
    `}

  ${({ type }) =>
    type === dna &&
    css`
      ${ImageWrapper} {
        width: ${em(149)};
        padding-left: ${em(9)};
        margin-right: ${em(33)};
      }

      ${BarWrapper} {
        padding-top: ${em(5)};
      }
    `}
`

export const BarWrapper = styled.div`
  padding-top: ${em(14)};
  width: 100%;
  position: relative;
`

export const ChartWrapper = styled.div`
  padding-top: ${em(14)};
  display: flex;
`

export const ImageWrapper = styled.div`
  width: ${em(155)};
  margin-right: ${em(30)};
  transform: translateY(${em(30)});
  opacity: 0;
`

export const Bar = styled.div`
  background: ${p =>
    p.isGray
      ? p.theme.colors.whiteOp2
      : 'linear-gradient(90deg, #4C32A0 0%, #7349FF 99.09%)'};
  min-width: ${em(7)};
  height: ${em(15)};
  border-top-right-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};
  border-bottom-right-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};
  position: absolute;
  width: ${({ barWidth }) => `${barWidth}%`};
`

export const TextStyled = styled(Text)`
  position: absolute;
  transform: translateY(${em(20)});
  opacity: 0;
`
